export const topics = [
    {
        id: 'ihr-bad',
        name: 'IHR BAD',
        componentPath: './ihr-bad/IhrBad',
        resources: [
            {
                name: 'Unser Service'
            },
            {
                name: 'Kundenreferenzen'
            },
            {
                name: 'Dusch-WC'
            },
            {
                name: 'Barrierefrei'
            },
            {
                name: 'Highlights'
            },
            {
                name: 'Freihandskizze'
            }
        ]
    },
    {
        id: 'sanitaer',
        name: 'SANITÄR',
        componentPath: './sanitaer/Sanitaer',
        resources: [
            {
                name: 'Unser Service'
            }
        ]
    },
    {
        id: 'heizung',
        name: 'HEIZUNG',
        componentPath: './heizung/Heizung',
        resources: [
            {
                name: 'Planung u. Angebot'
            },
            {
                name: 'Unser Service'
            },
            {
                name: 'Wärmepumpe'
            },
            {
                name: 'Energieträger'
            }
        ]
    },    
    {
        id: 'photovoltaik',
        name: 'PHOTOVOLTAIK',
        componentPath: './photovoltaik/Photovoltaik',
        resources: [
            {
                name: 'Planung u. Angebot'
            },
            {
                name: 'Unser Service'
            }
        ]
    }
];

export const subTopics = [
    {
        id: 'home',
        name: 'HOME',
        componentPath: './home/Home',
        resources: [
        ]
    },
    {
        id: 'ueber-uns',
        name: 'ÜBER UNS',
        componentPath: './ueber-uns/UeberUns',
        resources: [
            {
                name: 'Im Büro'
            },
            {
                name: 'Bei Ihnen vor Ort'
            },
            {
                name: 'Unsere Firmenhistorie'
            },
            {
                name: 'Wir bilden aus'
            }
        ]
    },
    {
        id: 'kontakt',
        name: 'KONTAKT',
        componentPath: './kontakt/Kontakt',
        resources: [
            {
                name: 'Anschrift'
            }
        ]
    }
];

export const offTopics = [
    {
        id: 'impressum-datenschutzhinweise',
        name: 'Impressum | Datenschutzhinweise',
        componentPath: './impressum/Impressum',
        resources: [
            {
                name: 'Impressum'
            },
            {
                name: 'Datenschutzhinweise'
            }
        ]
    }
];

const Navigation = {};
export default Navigation;


// WEBPACK FOOTER //
// ./src/Navigation.js